import CONST from '../../../../../includes/primitives/_constant_trion'
export default {
  data: () => ({

    HOST: CONST.HOST_NAME_RESOURCE + '/resources',

    rawData:  [],
    areaData: [],
    
    circle: null,
    title: null,
    columns: null,

    keys: null,
    filters: null,
    
    canvasForms:  null,

  }),

  computed: {
    ready2draw() {
      return (
        this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
  },



}